export class CommonConfig {
  searchFilterValue: string = "";
  pageNumber: number = 0;
  startDate: Date = null;
  endDate: Date = null;
  propertyValuesIds: number[] = [];
}
